<template>
  <v-card variant="flat" class="bg-white px-4 py-2" style="height: 100%;overflow-y: auto !important;">
    <div class="d-flex align-center">
      <h3 class="font-weight-bold mb-4 mr-2">Client Locations</h3>
      <v-icon v-if="role < 6" @click="openDialog" class="mb-4">mdi mdi-plus-circle</v-icon>
    </div>
     <template v-if="locations && locations.length > 0">
      <div v-for="(location, index) in locations" :key="index">
    <div
      v-if="location.addressType.length != 0 && location.address1.length != 0 && location.deleted == 0"
      flat
      class="mb-2 d-flex flex-column justify-center py-3"
      style="border-radius: 12px; background-color: #f2f2f2; height: 100px; overflow-y: auto;"
    >
      <v-row align="center" no-gutters class="px-4 ">

        <v-col cols="6" class="d-flex align-center">
          <span class="mr-2 font-14 text-wrap" style="font-weight: bold; color: darkslateblue;">
            {{ `${location.address1}, ${location.address2}, ${location.address3}, ${location.city}, ${location.zip_code}` }}
          </span>
        </v-col>
      
        <v-col cols="1" class="d-flex align-center justify-center">
          <v-tooltip text="Official Website" location="top">
            <template #activator="{ props }">
              <v-icon
                v-bind="props"
                color="blue"
                class="cursor-pointer"
                @click="openWebPage(location.website)"
              >
                mdi-link-variant
              </v-icon>
            </template>
          </v-tooltip>
        </v-col>
      
        <v-col cols="1" class="d-flex align-center justify-center">
          <v-menu
            open-on-hover
            offset-y
            transition="scale-transition"
            close-delay="150"
          >
            <template #activator="{ props }">
              <div v-bind="props">
                <v-tooltip text="Click to open in Google Maps" location="top">
                  <template #activator="{ props: tooltipProps }">
                    <!-- <v-icon
                      v-bind="tooltipProps"
                      color="#DB4437"
                      class="cursor-pointer"
                      @mouseenter="isHovered = true"
                      @mouseleave="isHovered = false"
                      @click="openInMap(location)"
                    >
                      {{ isHovered ? 'mdi-map-marker' : 'mdi-map-marker-outline' }}
                    </v-icon> -->
                      <v-img
                        v-bind="tooltipProps"
                        src="@/assets/google-maps.png"  
                        width="24"
                        height="24"
                        class="cursor-pointer"
                        @click="openInMap(location)"
                        cover
                      ></v-img>
                  </template>
                </v-tooltip>
              </div>
            </template>
          
            <v-card width="400" height="300" class="pa-0">
              <iframe
                :src="googleMapEmbedUrl(location)"
                width="100%"
                height="300"
                style="border:0;"
                allowfullscreen
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </v-card>
          </v-menu>
        </v-col>
      
        <v-col cols="2" class="d-flex align-center justify-center">
          <div class="tag text-center px-3 py-1" style="background:#d9e5f5;border-radius:8px;">
            {{ location.addressType }}
          </div>
        </v-col>
      
        <!-- <v-col cols="1" class="d-flex align-center justify-center">
          <v-icon
            :color="location.active ? '#0DB768' : '#cc0a0a'"
            size="16"
            class="mr-1"
          >
            mdi-square
          </v-icon>
          <span class="active-class">
            {{ location.active ? "Active" : "Inactive" }}
          </span>
        </v-col> -->
        <v-col cols="1" class="d-flex align-center justify-center">
        <v-tooltip>
          <template #activator="{ props }">
            <span
              v-bind="props"
              class="radar-dot"
              :class="(location.active == 1 || location.active == 'ACTIVE') ? 'active' : 'inactive'"
            ></span>
          </template>
        
          {{ (location.active == 1 || location.active == 'ACTIVE') ? 'Active' : 'Inactive' }}
        </v-tooltip>
      <!-- </template> -->
          <!-- <span class="active-class">
            {{ location.active ? "Active" : "Inactive" }}
          </span> -->
        </v-col>
      
        <v-col cols="1" class="d-flex justify-end" v-if="role < 6" >
          <v-menu location="bottom">
            <template #activator="{ props }">
              <v-btn v-bind="props" icon variant="text" class="cursor-pointer">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
          
            <v-list density="compact">
              <v-list-item @click="editLocation(location, index)">
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteLocation(location, index)">
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>     
      </v-row>
      <!-- <v-row> -->
        <div class="modifydate px-6">
            <div v-if="location.modified_name && location.modified" class="mod">
               <v-tooltip :text="location.modified_name" location="top">
                <template #activator="{ props }">
                  <span
                    v-bind="props"
                    class="ma-1 py-1 px-1 chip"
                  >
                    {{ `${getTrimmedText(location?.modified_name) ?? ''}  ${location?.modified ? moment(location.modified).format('DD-MM-YYYY') : ''}`}}
                  </span>
                </template>
              </v-tooltip>
            </div>
        </div>
      <!-- </v-row> -->
    </div>

    </div>
     </template>
      <template v-else>
      <div  class="mb-2 pa-2 d-flex align-center justify-center"
      style="border-radius: 12px; background-color: #f2f2f2">
        No data available
      </div>
    </template>
  </v-card>
    
  <v-dialog v-if="dialog" v-model="dialog" width="650">
    <LocationForm
      :id="editId"
      :viewType="viewType"
      @close-dialog="closeDialog"
      @add-location="addLocation"
      @update-location="updateLocation"
      :editLocationData="editLocationData"
    />
  </v-dialog>
</template>

<script>
import LocationForm from "@/modules/ClientLocations/LocationForm.vue"
import clientDetailsService from "@/api/service/ClientDetails/ClientDetailsService";
import moment from "moment";
export default {
  components: {
    LocationForm
  },
  props:["location"],
  data: () => ({
    dialog:false,
    editLocationData:{},
    organisationData:[],
    viewType:"add",
    index:null,
    locations: [],
    user_id:null,
    user_name:null,
    role:null,
  }),
  created() {
    this.getOrganisation();

    let user = localStorage.getItem('user_details')
    user = JSON.parse(user)
    this.user_id = user.id
    this.user_name = user.username
    this.role = user.roles.role_type
    // console.log(this.user_id,"this.user_id!!")
  },
  methods: {
    moment,
    getTrimmedText(text) {
      return text && text.length <= 12 ? text : text && text.slice(0, 12) + ' ...';
    },
    openWebPage(website){
      window.open(website, '_blank');
    },
    openInMap(location) {
      console.log(location,"lclclclc");
      const address = `${location.address1} ${location.address2} ${location.address3} ${location.city} ${location.zip_code}`;
      const query = encodeURIComponent(address);
      window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank');
    },
    googleMapEmbedUrl(location) {
      const address = `${location.address1} ${location.address2} ${location.address3} ${location.city} ${location.zip_code}`;
      const query = encodeURIComponent(address);
      return `https://www.google.com/maps?q=${query}&output=embed`;
    },
     async getOrganisation() {
      let $id = this.$route.query.id
      this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
      this.locations = this.organisationData && this.organisationData.locations ? this.organisationData.locations : []
    },
    editLocation(item,index) {
      this.editLocationData = item;
      this.dialog=true;
      this.viewType="edit"
      this.index=index
    },
    closeDialog(){
      this.dialog = false
    },
    addLocation(data){
      console.log(data,"addloc");
      const now = moment().format('YYYY-MM-DD HH:mm:ss')

      data.id = this.locations.length + 1
      data.created = now
      data.modified = null
      data.created_by = this.user_id  
      data.modified_by = null
      data.active = 1
      data.deleted = 0
      data.deleted_by = null
      this.locations.push(data)
      console.log(data,"addloc");
      this.closeDialog()
      this.saveLocation()
    },
    updateLocation(data,index){
      // console.log(data,"upd");
        const now = moment().format('YYYY-MM-DD HH:mm:ss')
        data.modified = now
        data.modified_by = this.user_id
        data.modified_name = this.user_name
        data.deleted = 0
        data.deleted_by = null
        this.locations[index] = data;
        this.closeDialog()
        this.saveLocation()
    },
    openDialog(){
      this.dialog = true
      this.viewType="add"
      this.editLocationData = {}
    },

    async saveLocation(){
      this.organisationData.locations = this.locations
      let $data = {
        collectionName: 'organisation',
        data: this.organisationData,
        id:this.$route.query.id
      }
      await clientDetailsService.update($data)
    },
    deleteLocation(data,index){
      const now = moment().format('YYYY-MM-DD HH:mm:ss') 
      data.modified = now
      data.modified_by = this.user_id,
      data.active = 0
      data.deleted = 1
      data.deleted_by = this.user_id
      this.locations[index] = data;
      this.saveLocation()
      this.closeDialog() 
    }
  },
};
</script>

<style scoped>
.modifydate{
  display: flex;
  justify-content: end;
}
.mod{
  font-size: 12px;
  font-weight: 500;
}
.chip{
  font-size: 12px;
  font-weight: 600;
  color: crimson;
}
.tag {
  display: inline-block;
  padding: 4px 12px;
  border: 1px solid #16079c;
  border-radius: 8px;
  background-color: #f5f3ff;
  color: #16079c;
  font-size: 14px;
  font-weight: 500;
}
.font-14 {
  font-size: 16px;
}
.active-class {
  font-size: 14px;
  font-weight: 500;
}
.radar-dot {
  width: 15px;
  height: 15px;
  left: 15px;
  border-radius: 50%;
  position: relative;
  display: inline-block;
}

.radar-dot.active {
  background-color: #22c55e;
}

.radar-dot.active::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background: rgba(34, 197, 94, 0.5);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: radarPulseGreen 0.5s infinite ease-out;
}

.radar-dot.inactive {
  background-color: crimson;
}

.radar-dot.inactive::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background: rgba(220, 20, 60, 0.5);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: radarPulseRed 2s infinite ease-out;
}

@keyframes radarPulseGreen {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.7;
  }
  100% {
    transform: translate(-50%, -50%) scale(4.2); 
    opacity: 0;
  }
}

@keyframes radarPulseRed {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.7;
  }
  100% {
    transform: translate(-50%, -50%) scale(3.6); 
    opacity: 0;
  }
}
</style>
